import { render, staticRenderFns } from "./WondeLogsModal.vue?vue&type=template&id=0c395e62&scoped=true&"
import script from "./WondeLogsModal.vue?vue&type=script&lang=ts&"
export * from "./WondeLogsModal.vue?vue&type=script&lang=ts&"
import style0 from "./WondeLogsModal.vue?vue&type=style&index=0&id=0c395e62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c395e62",
  null
  
)

export default component.exports